import React, { useEffect } from "react";

const testimonials = [
  {
    name: "Priya & Arjun",
    occupation: "NRI Investors",
    comment:
      "Sweet Delights cakes are simply heavenly! The chocolate truffle is our favorite, always fresh and delicious.",
    photo: null,
  },
  {
    name: "Riya Sharma",
    occupation: "Food Blogger",
    comment:
      "The pastries here remind me of home. Loved the variety and the warmth in every bite.",
    photo: null,
  },
  {
    name: "Michael Brown",
    occupation: "Chef",
    comment:
      "High-quality ingredients and excellent baking techniques — this bakery sets a gold standard!",
    photo: null,
  },
];

function getInitials(name) {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
}

const Testimonials = () => {
  useEffect(() => {
    // Trigger Elfsight to load widgets
    const elfsightInterval = setInterval(() => {
      if (window.elfsight) {
        window.elfsight.load();
        clearInterval(elfsightInterval);
      }
    }, 500);
  }, []);

  return (
    <section className="testimonials-section" id="testimonials">
     
 <div class="elfsight-app-aa428358-fbe8-4e9c-83ee-02e94b6e016e" data-elfsight-app-lazy></div> 
      {/* Elfsight Google Reviews Widget */}
      {/* <div
        className="elfsight-app-aa428358-fbe8-4e9c-83ee-02e94b6e016e"
        data-elfsight-app-lazy
      ></div> */}

   
    </section>
  );
};

export default Testimonials;
